import { render, staticRenderFns } from "./PieSection.vue?vue&type=template&id=7f1ee3f0&scoped=true&"
import script from "./PieSection.vue?vue&type=script&lang=js&"
export * from "./PieSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ee3f0",
  null
  
)

export default component.exports